export const environment = {
  production: false,
  baseUrl: 'https://api.faithgrey.com',
  formspeeEndpoint: 'https://formspree.io/f/mrgnravn',
};
